import ListHeader from '../components/layout/ListHeader';
import ListFooter from '../components/layout/ListFooter';

interface LayoutListProps {
  children: React.ReactNode;
}

const ListPage: React.FC<LayoutListProps> = ({ children }) => (
  <>
    <ListHeader />
    <main>{children}</main>
    <ListFooter />
  </>
);
 
export default ListPage;